import type { Coverage } from '@/services/coverages/types';
import { businessQuotesService } from '@/services/quotes/business';
import { useQuery } from '@tanstack/react-query';

function getTodayVersionDate(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function useBusinessCoverages(activityPerformed?: string) {
  const versionDate = getTodayVersionDate();
  const normalizedActivity = (activityPerformed ?? '').trim();

  return useQuery({
    queryKey: [
      'business',
      'product-coverages',
      normalizedActivity,
      versionDate,
    ],
    enabled: Boolean(normalizedActivity),
    queryFn: async (): Promise<Coverage[]> => {
      const result = await businessQuotesService.getCoverages(
        normalizedActivity,
        versionDate
      );
      if (!result.success || !result.data) {
        throw new Error(result.error || 'Falha ao buscar coberturas');
      }
      return result.data;
    },
  });
}
